var _defs, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthParticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "ocean",
    cx: "35%",
    cy: "30%",
    r: "65%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5B9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1A3A5C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "shine",
    cx: "30%",
    cy: "25%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(255,255,255,0.35)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255,255,255,0)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18,
    fill: "url(#ocean)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6Q16 5 17 8Q18 12 16 15Q14 17 12 15Q10 12 11 9Q12 7 14 6Z",
    fill: "#4CAF50",
    opacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18Q15 17 16 20Q17 24 15 27Q13 29 11 27Q9 24 10 21Q11 19 13 18Z",
    fill: "#4CAF50",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8Q24 7 26 9Q27 12 26 15Q24 16 22 14Q21 11 22 8Z",
    fill: "#4CAF50",
    opacity: 0.85
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17Q26 16 27 19Q28 23 26 26Q24 28 22 26Q21 23 22 20Q23 18 24 17Z",
    fill: "#4CAF50",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10Q30 9 32 11Q33 14 31 16Q29 15 28 12Z",
    fill: "#4CAF50",
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18,
    fill: "url(#shine)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18,
    fill: "none",
    stroke: "rgba(135,206,250,0.3)",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthParticle);
export default __webpack_public_path__ + "static/media/earth-particle.5aab5cabc2b277c007b07e4d82305cf2.svg";
export { ForwardRef as ReactComponent };